<template>
  <apexchart type="donut" :options="chartOptions" :series="series" class="graph" />
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'DonutChart',
  props: {
    valores: Array,
  },
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    chartOptions: {
      labels: ['Atendidas', 'Abandonadas', 'Transbordo'],
      colors: ['#66BB6A', '#EF5350', '#FDD835'],
      legend: {
        show: false,
      },
      chart: {
        type: 'donut',
      },
      fill: {
        type: 'gradient',
      },
    },
    series: [],
  }),

  watch: {
    valores() {
      this.series.splice(0)
      this.series = [...this.valores]
    },
  },
}
</script>
